import { PureComponent, ReactNode } from 'react';
import Fuse from 'fuse.js';
import { GTreatmentPackage, GTreatmentService } from '../../../../../store/db';
import { getGArrayWithClinicId, getSelectedClinicId } from '../../../../../store/idbHandler';
import { getMyIdWithBackwardCompatibility } from '../../../../../api/mactiveid';
import { DB_TABLES } from '../../../../../store/dbTables';
import PadV2AutoSuggest, {
    AS_OPTIONS_FREQUENCTLY,
    AS_OPTIONS_SEARCH,
    AllOptions,
    CustomDataForAS,
} from '../../workspace/padV2/PadV2AutoSuggest';
import { Service } from '../../../../../api/getTreatmentPlans';

type Props = {
    onSelect: (option: any) => void;
    services: Service[];
    style?: { [key: string]: string };
    clinicId: string;
};

const fuseConfigForTreatmentServices = { keys: ['name'], threshold: 0.2, ignoreLocation: true };
const fuseConfigForTreatmentPackages = { keys: ['name', '_services'], threshold: 0.2 };

const customDataForAS: CustomDataForAS = {
    service: {
        optionIconText: (
            <svg
                className="w-7 h-10 fill-darwin-accent-investigations-ochre-800"
                viewBox="0 0 7 10"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M6.086 1.902C6.038 1.986 5.986 2.048 5.93 2.088C5.878 2.124 5.812 2.142 5.732 2.142C5.648 2.142 5.556 2.112 5.456 2.052C5.36 1.988 5.244 1.918 5.108 1.842C4.972 1.766 4.812 1.698 4.628 1.638C4.448 1.574 4.234 1.542 3.986 1.542C3.762 1.542 3.566 1.57 3.398 1.626C3.23 1.678 3.088 1.752 2.972 1.848C2.86 1.944 2.776 2.06 2.72 2.196C2.664 2.328 2.636 2.474 2.636 2.634C2.636 2.838 2.692 3.008 2.804 3.144C2.92 3.28 3.072 3.396 3.26 3.492C3.448 3.588 3.662 3.674 3.902 3.75C4.142 3.826 4.388 3.908 4.64 3.996C4.892 4.08 5.138 4.18 5.378 4.296C5.618 4.408 5.832 4.552 6.02 4.728C6.208 4.9 6.358 5.112 6.47 5.364C6.586 5.616 6.644 5.922 6.644 6.282C6.644 6.674 6.576 7.042 6.44 7.386C6.308 7.726 6.112 8.024 5.852 8.28C5.596 8.532 5.282 8.732 4.91 8.88C4.538 9.024 4.112 9.096 3.632 9.096C3.356 9.096 3.084 9.068 2.816 9.012C2.548 8.96 2.29 8.884 2.042 8.784C1.798 8.684 1.568 8.564 1.352 8.424C1.136 8.284 0.944 8.128 0.776 7.956L1.25 7.182C1.29 7.126 1.342 7.08 1.406 7.044C1.47 7.004 1.538 6.984 1.61 6.984C1.71 6.984 1.818 7.026 1.934 7.11C2.05 7.19 2.188 7.28 2.348 7.38C2.508 7.48 2.694 7.572 2.906 7.656C3.122 7.736 3.38 7.776 3.68 7.776C4.14 7.776 4.496 7.668 4.748 7.452C5 7.232 5.126 6.918 5.126 6.51C5.126 6.282 5.068 6.096 4.952 5.952C4.84 5.808 4.69 5.688 4.502 5.592C4.314 5.492 4.1 5.408 3.86 5.34C3.62 5.272 3.376 5.198 3.128 5.118C2.88 5.038 2.636 4.942 2.396 4.83C2.156 4.718 1.942 4.572 1.754 4.392C1.566 4.212 1.414 3.988 1.298 3.72C1.186 3.448 1.13 3.114 1.13 2.718C1.13 2.402 1.192 2.094 1.316 1.794C1.444 1.494 1.628 1.228 1.868 0.995999C2.108 0.763999 2.404 0.578 2.756 0.438C3.108 0.298 3.512 0.228 3.968 0.228C4.48 0.228 4.952 0.308 5.384 0.468C5.816 0.628 6.184 0.852 6.488 1.14L6.086 1.902Z" />
            </svg>
        ),
        optionIconBgClass: 'circle-lx',
    },
    package: {
        optionIconText: (
            <svg
                className="w-13 h-13 fill-darwin-accent-investigations-ochre-800"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M5.6875 0.640625C6.03906 0.476562 6.4375 0.476562 6.78906 0.640625L11.9219 3.00781C12.1094 3.10156 12.25 3.28906 12.25 3.5C12.25 3.73438 12.1094 3.92188 11.9219 4.01562L6.78906 6.38281C6.4375 6.54688 6.03906 6.54688 5.6875 6.38281L0.554688 4.01562C0.367188 3.92188 0.25 3.73438 0.25 3.5C0.25 3.28906 0.367188 3.10156 0.554688 3.00781L5.6875 0.640625ZM10.6562 5.42188L11.9219 6.00781C12.1094 6.10156 12.25 6.28906 12.25 6.5C12.25 6.73438 12.1094 6.92188 11.9219 7.01562L6.78906 9.38281C6.4375 9.54688 6.03906 9.54688 5.6875 9.38281L0.554688 7.01562C0.367188 6.92188 0.25 6.73438 0.25 6.5C0.25 6.28906 0.367188 6.10156 0.554688 6.00781L1.82031 5.42188L5.38281 7.0625C5.92188 7.32031 6.55469 7.32031 7.09375 7.0625L10.6562 5.42188ZM7.09375 10.0625L10.6562 8.42188L11.9219 9.00781C12.1094 9.10156 12.25 9.28906 12.25 9.5C12.25 9.73438 12.1094 9.92188 11.9219 10.0156L6.78906 12.3828C6.4375 12.5469 6.03906 12.5469 5.6875 12.3828L0.554688 10.0156C0.367188 9.92188 0.25 9.73438 0.25 9.5C0.25 9.28906 0.367188 9.10156 0.554688 9.00781L1.82031 8.42188L5.38281 10.0625C5.92188 10.3203 6.55469 10.3203 7.09375 10.0625Z" />
            </svg>
        ),
        optionIconBgClass: 'circle-lx',
    },
};

export const TREATMENT_SERVICES_AND_TREATMENT_PACKAGES_AS_INPUT =
    'TREATMENT_SERVICES_AND_TREATMENT_PACKAGES_AS_INPUT';

export const TREATMENT_SERVICES_AND_TREATMENT_PACKAGES_AS_EL =
    'TREATMENT_SERVICES_AND_TREATMENT_PACKAGES_AS_EL';

class AutoSuggest extends PureComponent<Props> {
    gTreatmentServicesFuse = new Fuse([] as GTreatmentService[], fuseConfigForTreatmentServices);
    gTreatmentPackagesFuse = new Fuse([] as GTreatmentPackage[], fuseConfigForTreatmentPackages);
    gTreatmentServicesElements: GTreatmentService[] | undefined;
    gTreatmentPackagesElements: GTreatmentPackage[] | undefined;

    componentDidMount = async (): Promise<void> => {
        const { clinicId } = this.props;
        const gTreatmentServices = getGArrayWithClinicId<GTreatmentService>(
            getMyIdWithBackwardCompatibility() || '',
            DB_TABLES['treatmentServices'],
            clinicId || '',
        );
        const gTreatmentPackages = getGArrayWithClinicId<GTreatmentPackage>(
            getMyIdWithBackwardCompatibility() || '',
            DB_TABLES['treatmentPackages'],
            clinicId || '',
        );
        Promise.all([gTreatmentServices, gTreatmentPackages]).then((values) => {
            let gTreatmentServices = values[0];
            let gTreatmentPackages = values[1];
            gTreatmentServices = gTreatmentServices.filter((i) => !i.archive);
            gTreatmentPackages = gTreatmentPackages.filter((i) => !i.archive);
            this.gTreatmentServicesFuse = new Fuse(
                gTreatmentServices,
                fuseConfigForTreatmentServices,
            );
            this.gTreatmentPackagesFuse = new Fuse(
                gTreatmentPackages.map((t) => ({
                    ...t,
                    _services: t.services?.map((i) => i.name).join(', '),
                })),
                fuseConfigForTreatmentPackages,
            );
            this.gTreatmentServicesElements = gTreatmentServices;
            this.gTreatmentPackagesElements = gTreatmentPackages;
        });
    };

    OptionIcon = (
        <svg
            className="w-7 h-10 fill-darwin-accent-investigations-ochre-800"
            viewBox="0 0 7 10"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M6.086 1.902C6.038 1.986 5.986 2.048 5.93 2.088C5.878 2.124 5.812 2.142 5.732 2.142C5.648 2.142 5.556 2.112 5.456 2.052C5.36 1.988 5.244 1.918 5.108 1.842C4.972 1.766 4.812 1.698 4.628 1.638C4.448 1.574 4.234 1.542 3.986 1.542C3.762 1.542 3.566 1.57 3.398 1.626C3.23 1.678 3.088 1.752 2.972 1.848C2.86 1.944 2.776 2.06 2.72 2.196C2.664 2.328 2.636 2.474 2.636 2.634C2.636 2.838 2.692 3.008 2.804 3.144C2.92 3.28 3.072 3.396 3.26 3.492C3.448 3.588 3.662 3.674 3.902 3.75C4.142 3.826 4.388 3.908 4.64 3.996C4.892 4.08 5.138 4.18 5.378 4.296C5.618 4.408 5.832 4.552 6.02 4.728C6.208 4.9 6.358 5.112 6.47 5.364C6.586 5.616 6.644 5.922 6.644 6.282C6.644 6.674 6.576 7.042 6.44 7.386C6.308 7.726 6.112 8.024 5.852 8.28C5.596 8.532 5.282 8.732 4.91 8.88C4.538 9.024 4.112 9.096 3.632 9.096C3.356 9.096 3.084 9.068 2.816 9.012C2.548 8.96 2.29 8.884 2.042 8.784C1.798 8.684 1.568 8.564 1.352 8.424C1.136 8.284 0.944 8.128 0.776 7.956L1.25 7.182C1.29 7.126 1.342 7.08 1.406 7.044C1.47 7.004 1.538 6.984 1.61 6.984C1.71 6.984 1.818 7.026 1.934 7.11C2.05 7.19 2.188 7.28 2.348 7.38C2.508 7.48 2.694 7.572 2.906 7.656C3.122 7.736 3.38 7.776 3.68 7.776C4.14 7.776 4.496 7.668 4.748 7.452C5 7.232 5.126 6.918 5.126 6.51C5.126 6.282 5.068 6.096 4.952 5.952C4.84 5.808 4.69 5.688 4.502 5.592C4.314 5.492 4.1 5.408 3.86 5.34C3.62 5.272 3.376 5.198 3.128 5.118C2.88 5.038 2.636 4.942 2.396 4.83C2.156 4.718 1.942 4.572 1.754 4.392C1.566 4.212 1.414 3.988 1.298 3.72C1.186 3.448 1.13 3.114 1.13 2.718C1.13 2.402 1.192 2.094 1.316 1.794C1.444 1.494 1.628 1.228 1.868 0.995999C2.108 0.763999 2.404 0.578 2.756 0.438C3.108 0.298 3.512 0.228 3.968 0.228C4.48 0.228 4.952 0.308 5.384 0.468C5.816 0.628 6.184 0.852 6.488 1.14L6.086 1.902Z" />
        </svg>
    );

    getOptions = (
        setOptions: (options: AllOptions<any>, inputValue?: string) => void,
        input?: string,
    ): void => {
        const options: AllOptions<any> = [];
        const { services } = this.props;
        if (!input?.trim()) {
            let genieTreatmentServicesOptions =
                this.gTreatmentServicesElements?.filter(Boolean) || [];
            genieTreatmentServicesOptions = genieTreatmentServicesOptions.filter(
                (i) => !services.find((s) => s.id === i.service_id),
            );
            genieTreatmentServicesOptions.splice(7);
            genieTreatmentServicesOptions = genieTreatmentServicesOptions.map((i) => ({
                ...i,
                type: 'service',
                id: i.service_id,
            }));
            if (genieTreatmentServicesOptions.length > 0) {
                options.push({
                    label: AS_OPTIONS_FREQUENCTLY,
                    options: genieTreatmentServicesOptions,
                    autosuggestHeading: 'Services',
                });
            }
            let genieTreatmentPackagesOptions =
                this.gTreatmentPackagesElements?.filter(Boolean) || [];
            genieTreatmentPackagesOptions.splice(7);
            genieTreatmentPackagesOptions = genieTreatmentPackagesOptions.map((i) => ({
                ...i,
                type: 'package',
                id: i.package_id,
            }));
            if (genieTreatmentPackagesOptions.length > 0) {
                options.push({
                    label: AS_OPTIONS_FREQUENCTLY,
                    options: genieTreatmentPackagesOptions,
                    autosuggestHeading: 'Packages',
                });
            }
            setOptions(options, input);
        } else {
            let filteredGTreatmentServicesItems = this.gTreatmentServicesFuse
                .search(input)
                .map((option) => option.item)
                .filter(Boolean)
                .map((t) => ({ ...t, track: { source: 'GENIE' } }));
            filteredGTreatmentServicesItems = filteredGTreatmentServicesItems.filter(
                (i) => !services.find((s) => s.id === i.service_id),
            );
            filteredGTreatmentServicesItems.splice(7);
            filteredGTreatmentServicesItems = filteredGTreatmentServicesItems.map((i) => ({
                ...i,
                type: 'service',
                id: i.service_id,
            }));
            if (filteredGTreatmentServicesItems.length > 0) {
                options.push({
                    label: AS_OPTIONS_SEARCH as typeof AS_OPTIONS_SEARCH,
                    options: filteredGTreatmentServicesItems,
                    autosuggestHeading: 'Services',
                });
            }
            let filteredGTreatmentPackagesItems = this.gTreatmentPackagesFuse
                .search({ $or: [{ name: input }, { _services: input }] })
                .map((option) => option.item)
                .filter(Boolean)
                .map((t) => ({ ...t, track: { source: 'GENIE' } }));
            filteredGTreatmentPackagesItems.splice(7);
            filteredGTreatmentPackagesItems = filteredGTreatmentPackagesItems.map((i) => ({
                ...i,
                type: 'package',
                id: i.package_id,
            }));
            if (filteredGTreatmentPackagesItems.length > 0) {
                options.push({
                    label: AS_OPTIONS_SEARCH as typeof AS_OPTIONS_SEARCH,
                    options: filteredGTreatmentPackagesItems,
                    autosuggestHeading: 'Packages',
                });
            }
            setOptions(options, input);
        }
    };

    render(): ReactNode {
        const { onSelect, style } = this.props;

        return (
            <PadV2AutoSuggest
                inputId={TREATMENT_SERVICES_AND_TREATMENT_PACKAGES_AS_INPUT}
                elId={TREATMENT_SERVICES_AND_TREATMENT_PACKAGES_AS_EL}
                onSelect={onSelect}
                optionIconText={this.OptionIcon}
                optionIconBgClass="circle-lx"
                menuListClassName="lx-dropdown"
                optionWrapperClass="lx-dropdown-item"
                getOptions={this.getOptions}
                placeholder="Select service(s) / package(s)"
                elements={[]}
                hideKeyboardShortCutsInfo
                customDataForAS={customDataForAS}
                style={style}
            />
        );
    }
}

export default AutoSuggest;
